import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingScreenProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  text?: string;
  fullScreen?: boolean;
}

export function LoadingScreen({ 
  className, 
  size = "md", 
  text, 
  fullScreen = true 
}: LoadingScreenProps) {
  const sizeClasses = {
    sm: "h-5 w-5",
    md: "h-8 w-8", 
    lg: "h-12 w-12"
  };

  const containerClasses = fullScreen 
    ? "min-h-screen flex items-center justify-center"
    : "flex items-center justify-center p-8";

  return (
    <div className={cn(containerClasses, className)}>
      <div className="flex flex-col items-center gap-3">
        <Loader2 className={cn(sizeClasses[size], "animate-spin text-orange-500")} />
        {text && (
          <p className="text-sm text-gray-600 space-grotesk uppercase">
            {text}
          </p>
        )}
      </div>
    </div>
  );
}
